export const environment = {
  apiUrl: 'https://cdhb-api-dev.procedurecard.com',
  production: false,
};
